import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useMerchantsListFilterFields } from './hooks/useMerchantsListFilterFields';

export const MerchantsListFilterChips: React.FC = () => {
  const fields = useMerchantsListFilterFields();

  return <FilterChips fields={fields} />;
};
